import { Container, Row } from "react-bootstrap";
import { LogsToolbar } from "./LogsToolbar";
import { useLocalization } from "../../contexts/LocalizationContext";
import { useSearchParams } from "react-router-dom";
import { PluginLogsFilters } from "./models/PluginLogsFilters";
import { applyPluginLogsFilter } from "./actions/applyPluginLogsFilters";
import { PluginLogsFilterActionType } from "./models/PluginLogsFilterActionType";
import { updatePluginLogsFilters } from "./actions/updatePluginLogsFilters";
import { AppliedPluginLogFilters } from "./AppliedPluginLogFilters";
import { useLogs } from "./hooks/useLogs";
import { useEffect } from "react";
import { ContainerLoader } from "../common/progress/Loader";

export const Logs = () => {
  const { data: logs, isLoading, getLogs } = useLogs();
  const [searchParams, setSearchParams] = useSearchParams();
  const { translate } = useLocalization();
  const filters = new PluginLogsFilters(searchParams);
  const filtered = applyPluginLogsFilter(filters, logs ?? []);

  const handleFiltersChange = (action: PluginLogsFilterActionType, value?: string) => {
    setSearchParams(updatePluginLogsFilters(filters, action, value).toString());
  };

  useEffect(() => {
    getLogs();
  }, []);

  return (
    <div className="max-vh-100 overflow-y">
      <Container className="p-3 border-bottom">
        <Row>
          <LogsToolbar filters={filters} handleFiltersChange={handleFiltersChange} />
        </Row>
        <Row className="mt-2">
          <AppliedPluginLogFilters filters={filters} handleFiltersChange={handleFiltersChange} />
        </Row>
      </Container>
      <Container>
        <div className="position-relative" style={{ height: "80vh", overflowY: "auto" }}>
          {isLoading && <ContainerLoader />}

          {!isLoading && filtered.length === 0 ? (
            <div className="py-3">{translate("plugins.noLogs")}</div>
          ) : (
            filtered
              .slice()
              .reverse()
              .map((x) => (
                <div key={x.id} className="p-3 border-bottom" dangerouslySetInnerHTML={{ __html: x.content }} />
              ))
          )}
        </div>
      </Container>
    </div>
  );
};
